var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgCalendarRepeat = function SvgCalendarRepeat(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.292 14.6628L11.563 13.8818L10.834 14.6628",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8341 17.4052C16.2871 17.7782 15.6291 18.0002 14.9171 18.0002C13.0271 18.0002 11.4951 16.4682 11.4951 14.5782C11.4951 14.3492 11.5191 14.1252 11.5621 13.9082",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.542 14.564L18.271 15.344L19 14.564",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.999 11.822C13.546 11.449 14.204 11.228 14.916 11.228C16.806 11.228 18.338 12.76 18.338 14.65C18.338 14.879 18.314 15.102 18.27 15.32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13 1V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5 1V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1 6H17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17 8V4C17 2.895 16.105 2 15 2H3C1.895 2 1 2.895 1 4V15C1 16.105 1.895 17 3 17H8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.99901 8.75C4.86101 8.75 4.74901 8.862 4.75001 9C4.75001 9.138 4.86201 9.25 5.00001 9.25C5.13801 9.25 5.25001 9.138 5.25001 9C5.25001 8.862 5.13801 8.75 4.99901 8.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.99901 12.75C4.86101 12.75 4.74901 12.862 4.75001 13C4.75001 13.138 4.86201 13.25 5.00001 13.25C5.13801 13.25 5.25001 13.138 5.25001 13C5.25001 12.862 5.13801 12.75 4.99901 12.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M8.75 9.001C8.75 9.139 8.862 9.251 9 9.25C9.138 9.25 9.25 9.138 9.25 9C9.25 8.862 9.138 8.75 9 8.75C8.862 8.75 8.75 8.862 8.75 9.001Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarRepeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-repeat.07c4559d.svg";
export { ForwardRef as ReactComponent };